import { render, staticRenderFns } from "./DatosCuadroPantalla.vue?vue&type=template&id=d1c583ea&scoped=true"
import script from "./DatosCuadroPantalla.vue?vue&type=script&lang=js"
export * from "./DatosCuadroPantalla.vue?vue&type=script&lang=js"
import style0 from "./DatosCuadroPantalla.vue?vue&type=style&index=0&id=d1c583ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c583ea",
  null
  
)

export default component.exports